import statusesId from '@/constants/statusesId';

export default {
    data () {
        return {
            statusesId
        };
    },
    computed: {
        statusValue () {
            return (
                this.$store.getters['family/getFamily'] &&
        this.$store.getters['family/getFamily'].status.family_edition_status_id
            );
        },
        isSheetReturned () {
            return (
                this.statusValue === this.statusesId.SEND_BACK_AREA_REACH ||
        this.statusValue === this.statusesId.SEND_BACK_NATIONAL_REACH
            );
        },
        isSheetPublicationRevoked () {
            return this.statusValue === this.statusesId.PUBLICATION_REVOKED;
        }
    }
};
